var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"text-center mt-5 text-danger"},[_vm._v("На жаль у Вас немає повноважень користуватися даною послугою")])])}]

export { render, staticRenderFns }